"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomClaimWatcher = void 0;
var tslib_1 = require("tslib");
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var auth_1 = require("firebase/auth");
var patchCustomClaimApi_1 = require("../../apis/patch/patchCustomClaimApi");
var createErrorAction_1 = require("../../actionCreators/createErrorAction");
var description = 'CustomClaimWatcher';
var CustomClaimWatcher = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var role = (0, react_redux_1.useSelector)(function (state) {
        var _a;
        var currentUserId = state.currentUserId;
        var userRoles = (_a = state.currentWorkspace) === null || _a === void 0 ? void 0 : _a.userRoles;
        var userRole = currentUserId && userRoles && userRoles[currentUserId];
        return userRole && userRole.role;
    });
    var currentWorkspaceId = (0, react_redux_1.useSelector)(function (state) {
        return state.currentWorkspaceId;
    });
    (0, react_1.useEffect)(function () {
        var processCustomClaim = function () { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
            var currentUser, tokenResult, customClaim, customClaimRole, values, results, error_1;
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        currentUser = (0, auth_1.getAuth)().currentUser;
                        if (!(currentUser && currentWorkspaceId)) return [3 /*break*/, 7];
                        return [4 /*yield*/, currentUser.getIdTokenResult()];
                    case 1:
                        tokenResult = _b.sent();
                        customClaim = tokenResult.claims;
                        customClaimRole = (_a = customClaim.roles) === null || _a === void 0 ? void 0 : _a[currentWorkspaceId];
                        if (!(customClaimRole === role)) return [3 /*break*/, 2];
                        dispatch({
                            type: 'GET_CUSTOM_CLAIM_SUCCESS',
                            description: description,
                            requestValues: {},
                            successValues: {
                                item: customClaim,
                            },
                        });
                        return [3 /*break*/, 7];
                    case 2:
                        if (!role) return [3 /*break*/, 7];
                        values = {
                            workspaceId: currentWorkspaceId,
                        };
                        _b.label = 3;
                    case 3:
                        _b.trys.push([3, 6, , 7]);
                        return [4 /*yield*/, (0, patchCustomClaimApi_1.patchCustomClaimApi)({
                                apiHeaders: { token: tokenResult.token },
                                values: values,
                            })
                            // custom claim was updated so we need to refresh the token
                        ];
                    case 4:
                        results = _b.sent();
                        // custom claim was updated so we need to refresh the token
                        return [4 /*yield*/, currentUser.getIdTokenResult(true)];
                    case 5:
                        // custom claim was updated so we need to refresh the token
                        _b.sent();
                        dispatch({
                            type: 'PATCH_CUSTOM_CLAIM_SUCCESS',
                            description: description,
                            requestValues: values,
                            successValues: results.data,
                        });
                        return [3 /*break*/, 7];
                    case 6:
                        error_1 = _b.sent();
                        dispatch((0, createErrorAction_1.createErrorAction)({
                            error: error_1,
                            description: description,
                        }));
                        dispatch({
                            type: 'PATCH_CUSTOM_CLAIM_FAILURE',
                            description: description,
                            requestValues: values,
                        });
                        return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        }); };
        processCustomClaim();
    }, [currentWorkspaceId, role, dispatch]);
    return null;
};
exports.CustomClaimWatcher = CustomClaimWatcher;
